"use client"

import { useSearchParams } from "next/navigation"
import { useEffect, useState } from "react"

import { initAnalytics } from "@/services/mixpanel/utils/initMixpanel"
import { trackEvent } from "@/services/mixpanel/utils/trackEvent"
import { usePathname } from "@/utils/navigation"

export function MixpanelAnalytics() {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  const [isAnalyticsInit] = useState(initAnalytics())

  useEffect(() => {
    if (!isAnalyticsInit) {
      return
    }

    // Track page views
    if (pathname) {
      const url = `${pathname}${searchParams ? `?${searchParams}` : ""}`
      trackEvent("Page Viewed", {
        page: pathname,
        url,
        search: searchParams?.toString(),
      })
    }
  }, [isAnalyticsInit, pathname, searchParams])

  return null
}
